/**
 * Fisher-Yates (Knuth) shuffle algorithm.
 * Returns a new shuffled array without modifying the original.
 */
export function fisherYatesShuffle(array: number[]): number[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/**
 * Generate an array of numbers from min to max (inclusive).
 */
export function generateRange(min: number, max: number): number[] {
  const range: number[] = [];
  for (let i = min; i <= max; i++) {
    range.push(i);
  }
  return range;
}
